export default "__VITE_ASSET__Ca7h_LEw__"